import { FormatDateTimeFromDate } from "./FormatDateTimeFromDate";
import { ToOffset } from "./ToOffset";

export function ToDateStringNoTime(date: Date): string {
    return FormatDateTimeFromDate(ToOffset(date, 2));
}